import { render, staticRenderFns } from "./TouchpointOverviewRow.vue?vue&type=template&id=20d82914&"
import script from "./TouchpointOverviewRow.vue?vue&type=script&lang=js&"
export * from "./TouchpointOverviewRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('20d82914')) {
      api.createRecord('20d82914', component.options)
    } else {
      api.reload('20d82914', component.options)
    }
    module.hot.accept("./TouchpointOverviewRow.vue?vue&type=template&id=20d82914&", function () {
      api.rerender('20d82914', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/TouchpointOverview/TouchpointOverviewRow.vue"
export default component.exports